// extracted by css-extract-rspack-plugin
export default {"spinner":"spinner-eTmWpj","loader_keyframes":"loader_keyframes-Oi4QXT","loaderKeyframes":"loader_keyframes-Oi4QXT"};